import React, {Component} from "react";

class Schedule extends Component {

	pageContent(title) {
		
		return(
		<div className="schedule">
		      		      
			<h1 className="font-weight-light">{title}</h1>
	        
        	<div className="dt-bk-color-light">  	
      		<div className="container dt-container ">
      		
	        	<div className="row align-items-center">
	    	
					<div className="col-lg-12 col-sm-12">
					    <p className="dt-text-large">
					    New Client
					    </p>
					    <p>
					    If you are a new client please download the intake packet,
					    complete the document, and email prior to your appointment. 
					    </p>
					    <a href={global.config.docs.intake} >Click to Download Intake Packet</a>
					 </div>
					          
				</div>	  
				
		    </div>
		    </div>
		    
		    <div className="container dt-container ">
		    	<div className="row align-items-center">
	    	
	    			{/*   
					<div className="col-lg-12 col-sm-12">
					    <p className="dt-text-large">
					    Schedule an Appointment
					    </p>
					    <p>
					    Please use the tool below to schedule your appointment.
					    </p>
					 </div>
					 
					     
					 <dayschedule-widget url='https://dianetaylor.dayschedule.com/appointment' options='{ 
				        "color": {
				            "primary": "#bd88ae",
				            "secondary": "#fff2f2"
				        }}'> 
				      </dayschedule-widget>
			  		*/}
			  
				</div>
			</div>
			
		    	
		</div>
		);
	}

    render() {
			
		document.title = global.config.pageTitles.schedule + 
							global.config.pageTitles.seperator +
							global.config.pageTitles.title;	
			
		let title = global.config.pageTitles.schedule;

        return (
            this.pageContent(title)
        );
        
    }

}

export default Schedule;

    
